import { PickersShortcutsItem } from '@mui/x-date-pickers-pro'
import { subMonths, subYears } from 'date-fns'

export const commonDataRangeShortCuts: PickersShortcutsItem<[Date, Date]>[] = [
  {
    label: 'Year to Date',
    getValue: () => {
      const to = new Date()
      const from = new Date(to.getFullYear(), 0, 1)
      return [from, to]
    },
  },
  {
    label: 'Last 3 Months',
    getValue: () => {
      const to = new Date()
      const from = subMonths(to, 2)
      return [from, to]
    },
  },
  {
    label: 'Last 6 Months',
    getValue: () => {
      const to = new Date()
      const from = subMonths(to, 5)
      return [from, to]
    },
  },
  {
    label: 'Last 12 Months',
    getValue: () => {
      const to = new Date()
      const from = subMonths(to, 12)
      return [from, to]
    },
  },
  {
    label: 'Last 2 Years',
    getValue: () => {
      const to = new Date()
      const from = subYears(to, 2)
      return [from, to]
    },
  },
  {
    label: 'Last 3 Years',
    getValue: () => {
      const to = new Date()
      const from = subYears(to, 3)
      return [from, to]
    },
  },
  {
    label: 'All Time',
    getValue: () => {
      const from = new Date('2019-01-01T12:00:00.000Z')
      const to = new Date()
      return [from, to]
    },
  },
]
